import { FC, ReactElement } from 'react';
import { useCallStateHooks } from '@stream-io/video-react-sdk';
import { Form } from 'react-bootstrap';
import i18next from 'i18next';

type DeviceSettingsPanelProps = {
  onClose: () => void;
};

const DeviceSettingsPanel: FC<DeviceSettingsPanelProps> = (): ReactElement => {
  const { useCameraState, useMicrophoneState } = useCallStateHooks();
  const { camera, devices: cameraDevices, selectedDevice: selectedCamera } = useCameraState();
  const { microphone, devices: micDevices, selectedDevice: selectedMic } = useMicrophoneState();

  return (
    <div
      className="position-absolute bottom-100 start-50 translate-middle-x mb-2 p-3"
      style={{
        backgroundColor: '#0b1118',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: '1rem',
        minWidth: '280px',
        zIndex: 100,
        boxShadow: '0 -8px 32px rgba(0,0,0,0.5)',
      }}
    >
      <div className="mb-3">
        <div
          className="text-uppercase fw-semibold mb-2"
          style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.7rem', letterSpacing: '0.06rem' }}
        >
          {i18next.t('callPreview.camera')}
        </div>
        <Form.Select
          value={selectedCamera ?? ''}
          onChange={(e) => void camera.select(e.target.value).catch(() => undefined)}
          style={{
            backgroundColor: '#122033',
            borderColor: 'rgba(255,255,255,0.1)',
            color: '#fff',
            fontSize: '0.875rem',
          }}
        >
          {(cameraDevices ?? []).map((device: MediaDeviceInfo): ReactElement => (
            <option key={device.deviceId} value={device.deviceId}>
              {device.label || i18next.t('callPreview.camera')}
            </option>
          ))}
        </Form.Select>
      </div>

      <div>
        <div
          className="text-uppercase fw-semibold mb-2"
          style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.7rem', letterSpacing: '0.06rem' }}
        >
          {i18next.t('callPreview.microphone')}
        </div>
        <Form.Select
          value={selectedMic ?? ''}
          onChange={(e) => void microphone.select(e.target.value).catch(() => undefined)}
          style={{
            backgroundColor: '#122033',
            borderColor: 'rgba(255,255,255,0.1)',
            color: '#fff',
            fontSize: '0.875rem',
          }}
        >
          {(micDevices ?? []).map((device: MediaDeviceInfo): ReactElement => (
            <option key={device.deviceId} value={device.deviceId}>
              {device.label || i18next.t('callPreview.microphone')}
            </option>
          ))}
        </Form.Select>
      </div>
    </div>
  );
};

export default DeviceSettingsPanel;